import { Component, Input } from '@angular/core';
import { DateHelper } from '../../../../helpers/date.helper';

@Component({
  standalone: false,
  selector: 'app-machine-availability',
  templateUrl: './machine-availability.component.html',
  styleUrls: ['../availability.component.scss']
})

export class MachineAvailabilityComponent {
  @Input() availability: any;
  @Input() singleOrder: boolean;

  isOpen: boolean;

  constructor(public dateHelper: DateHelper) {
  }

  onToggle(): void {
    this.isOpen = !this.isOpen;
  }

  trackByFn(index: number): number {
    return index;
  }
}
